import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';
import { CustomQueryEncoderHelper } from '../customer-query-encoder-helper';

@Injectable()
export class WpAjaxService {

  private _ajaxUrl = '/wp-admin/admin-ajax.php?ts=' + (new Date()).getTime();
  private _action  = 'wfs_direct_ajax';
  private _headers = new HttpHeaders({'Content-Type' : 'application/x-www-form-urlencoded'});
  private _formData = new URLSearchParams('', new CustomQueryEncoderHelper());
  private _data: any;

  constructor(
    private http: HttpClient
  ) {
    this._formData.set('action', this._action);
  }

  post_request(data: any): Observable<any> {

    this._data = data;
    const options: any = this._setResponseType();

    this._urlSearchParams();

    return this.http.post(this._ajaxUrl, this._formData.toString(), options)
      .map(_r => _r);
  }

  post_request_async(data: any): Observable<any> {
    return this.http.post(
        this._ajaxUrl,
        this._generateFormData(data).toString(),
        {
            headers: this._headers
        }
    );
  }

  private _setResponseType(): any {
    const options: any = {
        headers: this._headers
    };

    if (this._data.response_type == null || this._data.response_type === undefined || this._data.response_type === '' ) {
        return options;
    }

    const responseType = this._data.response_type;
    delete this._data.response_type;

    return Object.assign(options, { responseType: responseType });
  }

  private _urlSearchParams(): void {
    if ( this._data === null || this._data === undefined ) {
        return;
    }

    for (const _i in this._data) {
      if (this._data.hasOwnProperty(_i)) {
        let _val = this._data[_i];
        if (_val instanceof Object) {
            _val = btoa(JSON.stringify(_val));
        }
        this._formData.set(_i, _val);
      }
    }
  }

  private _generateFormData(data: any): URLSearchParams {
    const formData = new URLSearchParams('', new CustomQueryEncoderHelper());
    formData.set('action', this._action);
    if ( data === null || data === undefined ) {
        return;
    }

    for (const _i in data) {
      if (data.hasOwnProperty(_i)) {
        let _val = data[_i];
        if (_val instanceof Object) {
            _val = btoa(JSON.stringify(_val));
        }
        formData.set(_i, _val);
      }
    }

    return formData;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/wp-ajax/wp-ajax.service.ts